module.exports = __webpack_public_path__ + "static/media/pencil.44b073d6.svg";